import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-account-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './account-page.component.html',
  styleUrl: './account-page.component.css'
})
export class AccountPageComponent {

}
